// Optimistic vibration helpers - always try, fail silently if unsupported
// Reports support for UI purposes, but always attempts vibration
export const supportsHaptics: boolean = (() => {
  if (typeof navigator === 'undefined') return false;
  // Report true if navigator.vibrate exists (even if it might not work)
  // This allows iOS users to toggle and test - better UX than blocking
  return 'vibrate' in navigator && typeof (navigator as any).vibrate === 'function';
})();

export const vibrate = (pattern: number | number[]) => {
  // Always try to vibrate regardless of supportsHaptics check
  // Let the browser/OS decide if it works or not
  if (typeof navigator === 'undefined') return;
  
  if ('vibrate' in navigator) {
    try {
      (navigator as any).vibrate(pattern);
    } catch (e) {
      // Silently fail - some platforms reject vibration
    }
  }
};

export const vibrateShort = () => vibrate(12);
export const vibrateMedium = () => vibrate([18, 30, 18]);
export const vibrateScore = () => vibrate([10, 40, 10, 60, 20]);
export const vibrateAchievement = () => vibrate([30, 40, 30, 120, 40]);

// Optional: expose manual visual pulse trigger
export const fallbackPulse = () => {};
